import { render, staticRenderFns } from "./LogboekIndex.vue?vue&type=template&id=7656d7e4&scoped=true&"
import script from "./LogboekIndex.vue?vue&type=script&lang=js&"
export * from "./LogboekIndex.vue?vue&type=script&lang=js&"
import style0 from "./LogboekIndex.vue?vue&type=style&index=0&id=7656d7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656d7e4",
  null
  
)

export default component.exports